import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { QuizHeader, CardMedia, resolveImage } from "../steps/shared";


const CATEGORY_CARDS = [
  { id: 5, label: "Spectacle Frames", sub: "Eyeglass frames for every face" },
  { id: 2, label: "Sunglasses", sub: "Shades for sun and style" },
  { id: 1, label: "Spectacle Lenses", sub: "Lenses that fit how you see" },
  { id: 3, label: "Contact Lenses", sub: "Daily, monthly and biweekly" },
];

const Step_one = ({ allCategories, onFilterChange, onSelectCategory }) => {
  const navigate = useNavigate();
  const isSignIn = useSelector((state) => state.auth.is_signin);

  const isLoading = !allCategories?.length;

  const cards = CATEGORY_CARDS.map((card) => {
    const data = allCategories?.find((c) => Number(c.id) === card.id);
    return data ? { ...card, data } : null;
  }).filter(Boolean);

  const handleCardClick = (data) => {
    if (!isSignIn) {
      navigate("/login"); 
      return;
    }


    onFilterChange("category", { id: data.id, name: data.name });
    onSelectCategory(data);
  };

  return (
    <section className="qz-step">
      <QuizHeader title="What are you looking for?" onBack={() => navigate("/")} />

      <div className="qz-grid qz-grid--fit" style={{ "--qz-cols": 4 }}>
        {isLoading
          ? CATEGORY_CARDS.map((c) => <div key={c.id} className="qz-skeleton" />)
          : cards.map(({ id, label, sub, data }) => (
              <button
                key={id}
                type="button"
                className="qz-card"
                onClick={() => handleCardClick(data)}
              >
                <CardMedia src={resolveImage(data)} alt={label} />
                <span className="qz-card__name">{label}</span>
                <span className="qz-card__sub">{sub}</span>
              </button>
            ))}
      </div>
    </section>
  );
};

export default Step_one;